export enum CustomActionEventEnum {
  FETCH_PAYER_DATA = 'fetch_payer_data',
}
